import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { Icon, Theme } from '..';
import { Title, Value, Variation } from './elements';
/**
 * A Kpi Block provides useful data pieces of information that should help users identity
 * the most important things about their data.
 *
 * @return {jsx}
 */

var KpiBlock = function KpiBlock(_ref) {
  var className = _ref.className,
      title = _ref.title,
      value = _ref.value,
      variation = _ref.variation,
      isCompacted = _ref.isCompacted;
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, variation !== false && variation < 0 && /*#__PURE__*/React.createElement(Variation, {
    negative: true,
    isCompacted: isCompacted
  }, variation.toFixed(2), " % ", /*#__PURE__*/React.createElement(Icon, {
    name: "caret-down",
    color: Theme.palette.failure["default"]
  })), variation !== false && variation >= 0 && /*#__PURE__*/React.createElement(Variation, {
    positive: true,
    isCompacted: isCompacted
  }, "+", variation.toFixed(2), " % ", /*#__PURE__*/React.createElement(Icon, {
    name: "caret-up",
    color: Theme.palette.success["default"]
  })), typeof value === 'string' && /*#__PURE__*/React.createElement(Value, {
    isCompacted: isCompacted
  }, value), React.isValidElement(value) && value, /*#__PURE__*/React.createElement(Title, {
    isCompacted: isCompacted
  }, title));
};
/**
 * PropTypes Validation
 */


var bool = PropTypes.bool,
    number = PropTypes.number,
    node = PropTypes.node,
    oneOfType = PropTypes.oneOfType,
    string = PropTypes.string;
KpiBlock.propTypes = {
  /**
   * Class needed by styled component
   */
  className: string,

  /**
   * If compacted, the block will have a smaller height and title, value and variation will stack in this order
   */
  isCompacted: bool,

  /**
   * Title displayed below the value
   */
  title: string.isRequired,

  /**
   * Value displayed at the center of the block
   */
  value: oneOfType([string, node]).isRequired,

  /**
   * Variation, positive or negative, displayed at the top right corner of the block
   */
  variation: oneOfType([bool, number])
};
/**
 * Default props
 */

KpiBlock.defaultProps = {
  className: '',
  isCompacted: false,
  variation: false
};
export default styled(KpiBlock).withConfig({
  displayName: "KpiBlock",
  componentId: "h87nm7-0"
})(["text-align:center;background:", ";border:1px solid ", ";border-radius:", ";box-shadow:0 1px 3px 0 rgba(0,0,0,0.04);box-sizing:content-box;display:grid;grid-template-areas:", ";height:", ";", ";padding:", ";position:relative;"], function (_ref2) {
  var palette = _ref2.theme.palette;
  return palette.white;
}, function (_ref3) {
  var palette = _ref3.theme.palette;
  return palette.lightGrey;
}, function (_ref4) {
  var dimensions = _ref4.theme.dimensions;
  return dimensions.radius;
}, function (_ref5) {
  var isCompacted = _ref5.isCompacted;
  return isCompacted ? "'title' 'value' 'variation'" : "'variation' 'value' 'title'";
}, function (_ref6) {
  var isCompacted = _ref6.isCompacted;
  return isCompacted ? '7.8rem' : '10rem';
}, function (_ref7) {
  var isCompacted = _ref7.isCompacted;
  return !isCompacted && css(["grid-template-rows:", ";"], function (_ref8) {
    var variation = _ref8.variation;
    return variation ? 'max-content max-content max-content' : 'auto max-content';
  });
}, function (_ref9) {
  var isCompacted = _ref9.isCompacted;
  return isCompacted ? '1.2rem' : '1rem';
});